<template>
  <div
    id="trainer-template"
    ref="cont"
    class="trainers-template tratmplt"
    :class="[`tratmplt_${iLength}`, { 'tratmplt_transitions-tmp-off': tmpDissTransitions }]"
    :style="`--trainer-fnt-size: ${fntSize}`"
  >
    <div
      v-for="(instance, idx) in instances"
      :key="`${idx}_back`"
      class="tratmplt_instance_back"
      :class="[instance, { tratmplt_instance_back_active: activeInstance === instance }]"
    ></div>

    <TrainerBackPattern class="tratmplt_pattern" />
    <div
      v-if="hasCenterCross"
      class="tratmplt_center_cross"
      :class="`tratmplt_center_cross_${iLength}`"
    ></div>

    <div
      v-for="(instance, idx) in instances"
      :key="`${idx}_outline`"
      class="tratmplt_instance_outline"
      :class="[instance, { tratmplt_instance_outline_active: activeInstance === instance }]"
    ></div>

    <div
      v-for="instance in instances"
      :key="instance"
      class="tratmplt_instance_front"
      :class="[instance]"
      @click="$emit('click', instance)"
      @mouseenter="$emit('mouseenter', instance)"
    >
      <slot :name="`slot_${instance}`"></slot>
    </div>

    <div class="tratmplt_center">
      <slot name="center" />
    </div>
  </div>
</template>

<script>
import TrainerBackPattern from '@/components/Trainer/TrainerBackPattern'
import { nextTick } from 'vue'

export default {
  name: 'TrainersTemplate',
  components: {
    TrainerBackPattern,
  },
  props: {
    instances: {
      default: () => ['alpha', 'beta', 'gamma', 'delta'],
    },
    activeInstance: String,
    hasCenterCross: Boolean,
  },
  emits: ['click', 'mouseenter'],
  data() {
    return {
      // sizeIncrement: 1,
      fntSize: 'clamp(1px, 1rem, 1.875vh)',
      // fntSize: 'clamp(1px, 1rem, 1.8vh)',
      tmpDissTransitions: false,
      sizeSet: false,
    }
  },
  // created() {
  //   this.sizeIncrement = (1 / this.iLength)
  // },
  mounted() {
    this.setSize()
  },
  methods: {
    setSize() {
      if (this.tmpDissTransitions) return
      this.tmpDissTransitions = true
      nextTick(() => {
        this.setFntSize()
        setTimeout(() => {
          this.tmpDissTransitions = false
        }, 0)
        setTimeout(() => {
          this.setFntSize()
          setTimeout(() => {
            this.setFntSize()
            setTimeout(() => {
              this.setFntSize()
            }, 200)
          }, 100)
        }, 50)
      })
    },
    setFntSize() {
      const {cont} = this.$refs
      if (cont) {
        const {iLength} = this
        let size = 'clamp(1px, 1rem, 1.875vh)'
        // let size = 'clamp(1px, 1rem, 1.8vh)'

        if (iLength > 1) {
          const { height, width } = cont.getBoundingClientRect()

          const boxWidth = width / 2
          const sizeWidth = this.getSizeByWidth(boxWidth)
          const boxHeight = height / (iLength === 2 ? 1 : 2)
          const sizeHeight = this.getSizeByHeight(boxHeight)

          size = sizeWidth > sizeHeight ? sizeHeight || sizeWidth : sizeWidth || sizeHeight
          size = size ? `${size}px` : '1rem'

          // const chosenSize = sizeWidth > sizeHeight ?
          //   sizeHeight ? 'sizeHeight' : 'sizeWidth' :
          //   sizeWidth ? 'sizeWidth' : 'sizeHeight'
          // console.log({
          //   chosenSize,
          //   iLength,
          //   size,
          //   boxWidth,
          //   boxHeight,
          //   sizeHeight,
          //   sizeWidth,
          //   width,
          //   height,
          // })
        }

        this.fntSize = size
        this.sizeSet = true
      }
    },
    getSizeByHeight(boxHeight) {
      let size = 0
      const b = [
        [800, 16],
        [750, 15.5],
        [700, 15],
        [650, 14.5],
        [625, 14],
        [600, 13.5],
        [575, 13],
        [550, 12.5],
        [525, 12],
        [500, 11.5],
        [475, 11],
        [450, 10.5],
        [425, 9.75],
        [400, 9.25],
        [375, 8.5],
        [350, 7.75],
        [325, 7.5],
        [310, 6.75],
      ]
      b.forEach(([w, s]) => {
        if (boxHeight < w) {
          size = s
        }
      })
      return size
    },
    getSizeByWidth(boxWidth) {
      let size = 0
      const b = [
        [1000, 13],
        [975, 12.75],
        [950, 12.5],
        [925, 12.25],
        [900, 12],
        [875, 11.75],
        [850, 11.5],
        [825, 11.25],
        [800, 11],
        [775, 10.75],
        [750, 10.5],
        [725, 10.25],
        [700, 10],
        [675, 9.75],
        [650, 9.25],
        [625, 9.125],
        [600, 8.625],
        [575, 8.125],
        [550, 7.5],
        [500, 7.25],
        [475, 7],
      ]
      b.forEach(([w, s]) => {
        if (boxWidth < w) {
          size = s
        }
      })
      return size
    },
  },
  computed: {
    iLength() {
      return this.instances.length
    },
    globals_window_size() {
      return this.$store.getters.globals_window_size
    },
    panelsProps() {
      return this.$store.getters.trainer_panels
    },
    focusMode() {
      return this.$store.getters.focus_mode
    },
  },
  watch: {
    globals_window_size: { immediate: false, handler: 'setSize' },
    focusMode: { immediate: false, handler: 'setSize' },
    instances: { immediate: false, handler: 'setSize' },
    panelsProps: { immediate: false, handler: 'setSize' },
  },
}
</script>
<style lang="scss">
.tratmplt {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  flex: 1;
  overflow: hidden;
  position: relative;

  --trainer-fnt-size: 1rem;
  font-size: var(--trainer-fnt-size);

  &_transitions-tmp-off {
    *:not(.transition-always-on) {
      transition: none !important;
    }
  }

  &_instance {
    &_back,
    &_outline,
    &_front {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      font-size: inherit;
      position: relative;
    }
    &_back {
      z-index: 1;
      --clr-instance-back: var(--clr-trainer_canvas_back);
      --glo-hs-back: var(--clr-instance-back);
      &:before,
      &:after {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        border-radius: 4px;
        box-sizing: border-box;
        transition: 0.3s;
      }
      &:before {
        background: var(--clr-instance-back);
        z-index: 0;
      }
    }
    &_outline {
      z-index: 4;
    }
    &_front {
      z-index: 4;
    }
  }
  &:not(.tratmplt_1) {
    .tratmplt_instance_back {
      &_active {
        z-index: 2;
        --clr-instance-back: var(--clr-trainer_active_canvas_back);
      }
    }
    .tratmplt_instance_outline {
      --clr-instance-outline: var(--clr-trainer_canvas_outline);
      &_active {
        --clr-instance-outline: var(--clr-trainer_active_canvas_outline);
      }
      &:after {
        content: '';
        // transition: 0.15s;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        border-radius: 4px;
        box-sizing: border-box;
        border: solid 2px var(--clr-instance-outline);
        z-index: 0;
      }
    }
  }
  &_pattern {
    position: fixed !important;
    z-index: 3;
    left: 0;
    top: 0;
  }
  &_center_cross {
    z-index: 3;
  }
  &_center {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4;
    height: 0;
    width: 0;
    // top: 0;
    // left: 0;
    // transition: 0.44s;
  }
  &_1 {
    .tratmplt_center {
      top: 25%;
      left: 50%;
    }
    .alpha {
      --focus-mode-center-margin: auto;
      grid-area: a;
    }
    grid-template-areas:
      'a a a a'
      'a a a a';
  }
  &_2 {
    .tratmplt_center {
      top: 25%;
      left: 50%;
    }
    .alpha {
      --focus-mode-center-margin: auto 0 auto auto;
      grid-area: a;
      --bdeg: -90deg;
    }
    .beta {
      --focus-mode-center-margin: auto auto auto 0;
      grid-area: b;
      --bdeg: 90deg;
    }
    grid-template-areas:
      'a a b b'
      'a a b b';
  }
  &_3 {
    .tratmplt_center {
      top: 50%;
      left: 50%;
    }
    .alpha {
      --focus-mode-center-margin: auto 0 auto auto;
      grid-area: a;
      --bdeg: 315deg;
    }
    .beta {
      --focus-mode-center-margin: auto auto auto 0;
      grid-area: b;
      --bdeg: 45deg;
    }
    .gamma {
      --focus-mode-center-margin: auto auto auto auto;
      grid-area: c;
      --bdeg: 180deg;
    }
    grid-template-areas:
      'a a b b'
      'c c c c';
  }
  &_4 {
    .tratmplt_center {
      top: 50%;
      left: 50%;
    }
    .alpha {
      --focus-mode-center-margin: auto 0 auto auto;
      grid-area: a;
      --bdeg: 315deg;
    }
    .beta {
      --focus-mode-center-margin: auto auto auto 0;
      grid-area: b;
      --bdeg: 45deg;
    }
    .gamma {
      --focus-mode-center-margin: auto 0 auto auto;
      grid-area: c;
      --bdeg: 225deg;
    }
    .delta {
      --focus-mode-center-margin: auto auto auto 0;
      grid-area: d;
      --bdeg: 135deg;
    }
    grid-template-areas:
      'a a b b'
      'c c d d';
  }
}

.tratmplt_center_cross {
  --size: 0;
  --size-vertical: 60vh;
  --size-horizontal: 60vw;

  --line-width: 2px;
  --radius: 4px;
  --color: var(--clr-black-1-3);
  --rotate: 0deg;
  flex-shrink: 0;
  transform: rotate(var(--rotate));
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:before,
  &:after {
    content: '';
    position: absolute;
    border-radius: var(--radius);
  }
  &:before {
    background-image: linear-gradient(180deg, transparent, var(--color), transparent);
    height: var(--size-vertical);
    width: var(--line-width);
  }
  &:after {
    background-image: linear-gradient(90deg, transparent, var(--color), transparent);
    height: var(--line-width);
    width: var(--size-horizontal);
  }

  &_2 {
    --size-vertical: 65vh;
    --size-horizontal: 0;
    &:before {
      top: -18vh;
    }
  }
  &_3 {
    --size-vertical: 30vh;
    --size-horizontal: 60vw;
    &:before {
      background-image: linear-gradient(180deg, transparent, var(--color));
      height: var(--size-vertical);
      width: var(--line-width);
      top: calc(var(--size-vertical) * -1);
    }
  }
  &_4 {
    --size-vertical: 60vh;
    --size-horizontal: 60vw;
  }
}

// keep for later maybe well return this
// @media (max-width: 1280px) {
//   .tratmplt {
//     &_2 {
//       .tratmplt_center {
//         top: 50%;
//         left: calc(100vw - 16rem);
//         transform: translate(0, -50%);
//         height: auto;
//       }
//       .alpha {
//         grid-area: a;
//         --bdeg: -90deg;
//         // --focus-mode-center-margin: auto;
//       }
//       .beta {
//         grid-area: b;
//         --bdeg: 90deg;
//         // --focus-mode-center-margin: auto;
//       }
//       grid-template-areas:
//         'a a a a'
//         'b b b b';
//     }
//   }
//   .tratmplt_center_cross {
//     &_2 {
//       --size-vertical: 0;
//       --size-horizontal: 60vh;
//       &:before {
//         top: unset;
//       }
//     }
//   }
// }
</style>

<style lang="scss">
// DISS this till Iam sure this is performant enough

// container queries create new context
// and so position fixed does not work well
// .tratmplt_singletable {
//   .tratmplt_instance_front {
//     container: singletable;
//     container-type: size;
//   }
// }
// .tratmplt_multitable {
//   .tratmplt_instance_front {
//     container: multitable;
//     container-type: size;
//   }
// }
// @container singletable (min-width: 1px) {
//   .tralay {
//     --min: 6px;
//     --mid: 1.35cqw;
//     --max: clamp(1px, 2.05cqh, 1rem);
//     font-size: clamp(var(--min), var(--mid), var(--max)) !important;
//   }
// }
// @container multitable (min-width: 1px) {
//   .tralay {
//     --min: 6px;
//     --mid: 1.35cqw;
//     --max: clamp(1px, 2.25cqh, 1.15rem);
//     font-size: clamp(var(--min), var(--mid), var(--max)) !important;
//   }
// }
</style>
